<div class="main_div">
  <div class="breadcrumb">
    <span
      class="donation_title cursor"
      [routerLink]="'/dashboard/donor-crm/dashboard'"
      >Home</span
    >
    <span> / Donor Info </span>
  </div>

  <div class="title" style="margin-bottom: 16px">Donor Info</div>
  <div class="main_body">
    <div class="contact_profile">
      <div class="title_main_body">Profile</div>
      <div class="upper_part">
        <div class="upper_upper_part">
          <div class="profile-avatar">
            <img
              class="profile_img"
              loading="lazy"
              [src]="
                donorsList?.profile_img?.url
                  ? donorsList?.profile_img?.url
                  : './assets/images/icon/profile_icon_gray.png'
              "
              alt="profile_pic"
            />
          </div>
          <div class="donor_name" style="margin-bottom: 8px; margin-top: 8px">
            {{ donorsList?.name }}
          </div>
          <div class="email">{{ donorsList?.email }}</div>
          <div class="number">{{ donorsList?.phone }}</div>
        </div>
        <div
          class="donor_name donation_time"
          style="
            margin-bottom: 8px;
            width: 100%;
            background-color: #e2f1ff;
            padding: 4px;
          "
        >
          <span class="donation_time" style="color: #0054a6; font-size: 18px"
            >Total donation: ৳ {{ donorsList.total_donation }}
          </span>
        </div>
        <div class="donations" style="width: 100%; text-align: start">
          <span class="donation_time">{{
            donorsList.last_donation | date : "dd MMM YYYY"
          }}</span
          >: {{ donorsList.last_donation | date : "hh:mm a" }}
        </div>
        <div class="donations" style="width: 100%; text-align: start">
          <span class="donation_time">{{
            donorsList.first_donation | date : "dd MMM YYYY"
          }}</span
          >: {{ donorsList.first_donation | date : "hh:mm a" }}
          PM
        </div>
        <div class="donations" style="width: 100%; text-align: start">
          <span class="donation_time">Donation Frequency</span>:
          {{ donorsList.donation_frequency }}
        </div>
        <div class="donations" style="width: 100%; text-align: start">
          <span class="donation_time">Supported Campaigns:</span>
          {{ donorsList.supported_campaigns }}
        </div>
      </div>
      <div class="buttons_invite_email">
        <dx-button
          class="blue-button-md send_email"
          [routerLink]="'/contact-us'"
        >
          {{ isNgoAdmin ? "Request Contact" : "Email Donor" }}
        </dx-button>
        <dx-button
          *ngIf="!isNgoAdmin"
          (click)="inviteDonatePopUpOpen()"
          class="yellow-button-md invite_btn"
          >Req. Donation</dx-button
        >
      </div>
      <div class="lower_part">
        <dx-drop-down-button
          *ngIf="!isNgoAdmin"
          class="drop_down_button"
          width="100%"
          [dropDownOptions]="{ width: '100%' }"
          [showArrowIcon]="true"
          text="Donors Contact Details"
          displayExpr="text"
          [items]="[
            {
              text: 'Donors Contact Details',
              icon: './assets/images/icon/whatsapp_icon.svg'
            }
          ]"
        ></dx-drop-down-button>
        <dx-drop-down-button
          class="drop_down_button"
          width="100%"
          [dropDownOptions]="{ width: '100%' }"
          [showArrowIcon]="true"
          text="Fundraising Team"
          displayExpr="text"
          [items]="donorsList.team_info"
        ></dx-drop-down-button>
        <dx-drop-down-button
          *ngIf="!isNgoAdmin"
          class="drop_down_button"
          width="100%"
          [dropDownOptions]="{ width: '100%' }"
          [showArrowIcon]="true"
          text="Donation Payment Method"
          displayExpr="text"
          [items]="[
            {
              text: 'Bkash',
              icon: './assets/images/icon/whatsapp_icon.svg'
            }
          ]"
        ></dx-drop-down-button>
      </div>
      <div class="retention_rate">
        <div class="retention_title_icon">
          <div class="retention_title">Average Donation Amount</div>
          <div class="retention_icon">
            <img
              src="./assets/images/icon/avg_donation.svg"
              alt="retention_icon"
            />
          </div>
        </div>
        <div class="percentage">
          ৳{{ donorsList.average_donation | number : "1.2-2" }}
        </div>
      </div>
    </div>
    <div class="recent_donations">
      <div class="title_main_body">Donation History</div>
      <div class="top_donor_div pr-0">
        <div class="donor_div">
          <dx-data-grid
            class="chart_div data_grid"
            [dataSource]="donorsList.recent_donations"
            [showBorders]="false"
            [showColumnLines]="false"
            [showRowLines]="false"
            [allowColumnResizing]="true"
            columnResizingMode="widget"
            [focusedRowEnabled]="false"
            [rowAlternationEnabled]="false"
            rowTemplate="rowTemplateName"
            [wordWrapEnabled]="true"
            [columnAutoWidth]="true"
          >
            <dxo-paging [pageSize]="9"></dxo-paging>
            <dxo-pager
              [visible]="true"
              [showPageSizeSelector]="false"
              allowedPageSizes="10"
              [showInfo]="true"
            ></dxo-pager>
            <dxi-column
              caption="Date & Time"
              dataField="created_at"
              [allowSorting]="false"
            ></dxi-column>
            <dxi-column
              *ngIf="!isNgoAdmin"
              caption="Payment & Receipt"
              dataField="transaction_id"
              [allowSorting]="false"
            >
            </dxi-column>
            <dxi-column
              caption="Campaign"
              dataField="campaign_title"
              alignment="start"
              [allowSorting]="false"
            >
            </dxi-column>
            <dxi-column
              caption="Comments"
              dataField="comment"
              alignment="start"
              [allowSorting]="false"
            >
            </dxi-column>
            <dxi-column
              caption="Amounts"
              dataField="donation_type"
              alignment="start"
              [allowSorting]="false"
            >
            </dxi-column>

            <tbody class="dx-row" *dxTemplate="let row of 'rowTemplateName'">
              <tr class="custom-row">
                <td>
                  <div class="transfer">
                    {{ row?.data?.created_at | date : "dd MMM yyyy" }}
                  </div>
                  <div class="transfer_time">
                    {{ row?.data?.created_at | date : "hh:mm a" }}
                  </div>
                </td>
                <td class="campaign_name" *ngIf="!isNgoAdmin">
                  <div class="transfer">
                    {{ row.data?.payment_receipt || "N/A" }}
                  </div>
                  <div
                    class="transfer blue_underline cursor"
                    (click)="showReceiptPopup(row?.data)"
                  >
                    {{ row?.data?.transaction_id || "N/A" }}
                  </div>
                </td>
                <td>
                  <div class="campaign_div blue">
                    {{
                      row?.data?.is_direct_donation
                        ? "Direct Donation"
                        : row?.data?.campaign_title
                    }}
                  </div>
                </td>
                <td>
                  <div class="left_side_property" style="margin: 12px">
                    <div class="name_amount">
                      <div class="name">{{ row?.data?.comment || "N/A" }}</div>
                    </div>
                  </div>
                </td>
                <td>
                  <div class="amount_div">
                    ৳ {{ row?.data?.amount | number : "1.2-2" }}
                  </div>
                  <div
                    [ngClass]="
                      row?.data?.status === 'Donated'
                        ? 'campaign_div'
                        : 'campaign_div'
                    "
                    [ngStyle]="{
                      color:
                        row?.data?.status === 'RECEIVED'
                          ? '#008000'
                          : row?.data?.status === 'PENDING'
                          ? '#0054a6'
                          : row?.data?.status === 'CONFIRMED' ||
                            row?.data?.status === 'DONATED'
                          ? '#FFAA33'
                          : '#D92D20'
                    }"
                  >
                    <li>
                      {{ row?.data?.status | titlecase }}
                    </li>
                  </div>
                </td>
              </tr>
            </tbody>
          </dx-data-grid>
        </div>
      </div>
    </div>
  </div>
</div>

<dx-popup
  [width]="'50vw'"
  [height]="'90vh'"
  [hideOnOutsideClick]="false"
  [showCloseButton]="true"
  [(visible)]="inviteDonatePopup"
  [showTitle]="false"
>
  <div class="root">
    <div
      class="cross_button_div_"
      style="margin-right: 20px; text-align: right; width: 100%"
    >
      <button class="cross_button" (click)="closeCreateEmailPopup()">
        <img
          src="../../../../../assets/images/icon/x-circle.svg"
          alt="cross"
          loading="lazy"
          title="close"
        />
      </button>
    </div>

    <div class="body">
      <div class="email_title popup2">Invite to Donate</div>
      <div class="email_subtitle">
        Invite this donor to donate to your campgin
      </div>

      <dx-select-box
        class="input_field"
        style="margin-bottom: 36px"
        width="100%"
        [dataSource]="['Campaign 1', 'Campaign 2']"
        [showClearButton]="true"
        [placeholder]="'Select a Campaign'"
      >
        <dx-validator validationGroup="validationGrp">
          <dxi-validation-rule type="required" message="Area is required.">
          </dxi-validation-rule>
        </dx-validator>
      </dx-select-box>

      <div style="width: 100%">
        <label class="value write">Write a message</label>
        <dx-text-area
          class="input_field"
          [height]="232"
          placeholder="Your messages here..."
        >
          <dx-validator validationGroup="validationGrp">
            <dxi-validation-rule
              type="required"
              message="Story Summery is required."
            >
            </dxi-validation-rule>
            <dxi-validation-rule
              type="stringLength"
              [max]="500"
              [trim]="false"
              message="500 characters maximum"
            >
            </dxi-validation-rule
          ></dx-validator>
        </dx-text-area>
      </div>
    </div>

    <div class="buttons">
      <dx-button class="blue-button-md blue-button">Send Invitation</dx-button>
    </div>
  </div>
</dx-popup>

<app-receipts [receipt]="receiptObject"></app-receipts>
